"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NavigationItem = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("./index.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

// Navigation
// ==========
var NavigationItem = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(NavigationItem, _Component);

  function NavigationItem() {
    (0, _classCallCheck2["default"])(this, NavigationItem);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(NavigationItem).apply(this, arguments));
  }

  (0, _createClass2["default"])(NavigationItem, [{
    key: "render",
    value: function render() {
      var _cx;

      var child = _react["default"].Children.only(this.props.children);

      return _react["default"].cloneElement(child, {
        onClick: this.props.onClick,
        className: (0, _classnames["default"])(_index["default"].NavigationItem, this.props.className, (_cx = {}, (0, _defineProperty2["default"])(_cx, _index["default"].active, this.props.active), (0, _defineProperty2["default"])(_cx, _index["default"].secondary, this.props.type === 'secondary'), _cx))
      });
    }
  }]);
  return NavigationItem;
}(_react.Component);

exports.NavigationItem = NavigationItem;
(0, _defineProperty2["default"])(NavigationItem, "propTypes", {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  type: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  active: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(NavigationItem, "defaultProps", {
  type: 'primary'
});

var Navigation = /*#__PURE__*/function (_Component2) {
  (0, _inherits2["default"])(Navigation, _Component2);
  (0, _createClass2["default"])(Navigation, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.expanded !== undefined && prevProps.expanded !== this.props.expanded) {
        this.setState({
          expanded: this.props.expanded
        });
      }
    }
  }]);

  function Navigation() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, Navigation);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Navigation).call(this, options));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      expanded: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickItem", function () {
      _this.setState({
        expanded: false
      });
    });
    _this.state.expanded = _this.props.expanded;
    return _this;
  }

  (0, _createClass2["default"])(Navigation, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_index["default"].Navigation, (0, _defineProperty2["default"])({}, _index["default"].expanded, this.state.expanded), this.props.className)
      }, _react["default"].createElement("nav", {
        className: (0, _classnames["default"])(_index["default"].itemsWrapper, (0, _defineProperty2["default"])({}, _index["default"].expanded, this.state.expanded))
      }, _react["default"].Children.map(this.props.children, function (child) {
        return _react["default"].cloneElement(child, {
          onClick: _this2.props.onClick || _this2.onClickItem
        });
      })));
    }
  }]);
  return Navigation;
}(_react.Component);

exports["default"] = Navigation;
(0, _defineProperty2["default"])(Navigation, "propTypes", {
  className: _propTypes["default"].string,
  expanded: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  children: _propTypes["default"].node
});
(0, _defineProperty2["default"])(Navigation, "defaultProps", {
  expanded: false
});